import { Outlet } from 'react-router-dom';
import { Topbar } from './Topbar.js';
import { Sidebar } from './Sidebar.js';

/**
 * Grid igual a la maqueta:
 *   - col 1 (232px): sidebar (row-span 2)
 *   - col 2 row 1 (56px): topbar
 *   - col 2 row 2 (1fr): main scrollable
 */
export function Layout(): JSX.Element {
  return (
    <div
      className="grid h-screen overflow-hidden"
      style={{ gridTemplateColumns: '232px 1fr', gridTemplateRows: '56px 1fr' }}
    >
      <Sidebar />
      <Topbar />
      <main className="col-start-2 overflow-y-auto overflow-x-hidden">
        <div className="px-9 pt-8 pb-16 max-w-[1280px]">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
